import React from 'react';
import {Container} from '@inlet/react-pixi';
import {RichText as RichTextDisplayObject} from '@gongxigames/framework/core/fragments/display';
import {Rectangle} from '@gongxigames/framework/core/fragments/react/components/Rectangle';
import {RichText} from '@gongxigames/framework/core/fragments/react/components/RichText';

export type TextVariables = Record<string, number | string>;
export type ReactButtonProps = {
    onClick: Function;
    width?: number;
    height?: number;
    borderColor?: number;
    borderThickness?: number;
    backgroundColor?: number;
    round?: number;
    disabled?: boolean;
    textId: string;
    textStyleId?: string;
    name?: string;
    textVariables?: TextVariables;
    horizontalPadding?: number;
    verticalPadding?: number;
};

type ReactButtonState = {
    width: number;
    height: number;
};

const DefaultProps: Partial<ReactButtonProps> = {
    horizontalPadding: 200,
    verticalPadding: 30,
    backgroundColor: 0xcccccc,
    borderColor: 0x000000,
    borderThickness: 3,
    textStyleId: 'DefaultStyle'
};

const DefaultTitle = 'ReactButtonTitle';

export class ReactButton extends React.Component<ReactButtonProps, ReactButtonState> {
    private text = React.createRef<RichTextDisplayObject>();

    constructor(props: ReactButtonProps) {
        super(props);

        this.state = {
            width: this.props.width || 0,
            height: this.props.height || 0
        };
    }

    protected getProps(): ReactButtonProps {
        return {...DefaultProps, ...this.props};
    }

    protected setAutoWidth(): void {
        const horizontalPadding = this.getProps()?.horizontalPadding || 0;
        const textWidth = this.text?.current?.width || 0;
        const width = textWidth + horizontalPadding * 2;

        this.setState({width});
    }

    protected setAutoHeight(): void {
        const verticalPadding = this.getProps()?.verticalPadding || 0;
        const textHeight = this.text?.current?.height || 0;
        const height = textHeight + verticalPadding * 2;

        this.setState({height});
    }

    public componentDidMount(): void {
        !this.props.width && this.setAutoWidth();
        !this.props.height && this.setAutoHeight();
    }

    public render(): JSX.Element {
        const {
            backgroundColor = 0,
            borderColor,
            borderThickness,
            textStyleId = '',
            round,
            disabled,
            textId,
            name = DefaultTitle,
            textVariables = {},
            width: w,
            height: h,
            ...containerProps
        } = this.getProps();
        const {height, width} = this.state;
        const buttonMiddleX = width / 2;
        const buttonMiddleY = height / 2;

        return (
            <Container name={name}
                interactive={!disabled} buttonMode={!disabled} pointertap={this.props.onClick.bind(this)} {...containerProps}>
                <Rectangle
                    width={width}
                    height={height}
                    fill={backgroundColor}
                    round={round}
                    border={{width: borderThickness, color: borderColor}} />
                <RichText ref={this.text} resolution={1}
                    x={buttonMiddleX} y={buttonMiddleY} id={textId} style={textStyleId} name={name} values={textVariables} />
            </Container>
        );
    }
}
